import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT01716806&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT01716806`,
  },
];

class NCT01716806 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container">
          <iframe style={{height:2600,width:'100%',border:'none'}} title="NCT01716806" src="https://connect.trialscope.com/studies/9c1d2acf-2f00-4a9b-aa9c-5a5e606d208e?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT01716806;
